module.exports = __webpack_public_path__ + "img/tracking_section.e71472ad.png";